export const isImage = (extension: string) => {
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
  return imageExtensions.includes(extension);
}

export const msToTime = (ms: number) => {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
  const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
  const seconds = (totalSeconds % 60).toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

export const convertToDateString = (input: string | null): string | null => {
  if (!input) return null;
  const date = new Date(input.split('T')[0]? input.split('T')[0] : `${input.split(' ')[0]}`);
  return `${date.toISOString().split('T')[0]}`;
};
